import React, { useState } from "react";

import telecomImg from "../../assets/Telecom-and-Media-isometric-8bit.png";

import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";
import { TbSettingsCog } from "react-icons/tb";
import { FaRobot } from "react-icons/fa";

const styles = `
  .telecom-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .telecom-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .telecom-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47, 183, 164, 0.7);
  }

  .telecom-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 100%;
    max-width: 520px;
    box-sizing: border-box;
  }

  .telecom-header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .telecom-header-badge span:first-of-type {
    font-size: 14px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .telecom-arrow {
    margin-left: auto;
    flex-shrink: 0;
  }

  .telecom-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .telecom-triangle-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .telecom-triangle-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .telecom-title-group {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .telecom-title-group h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .telecom-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .telecom-img-wrapper {
    flex: 1;
  }

  .telecom-img-wrapper img {
    width: 100%;
    max-width: 650px;
    display: block;
  }

  .telecom-accordion {
    flex: 1.2;
  }

  .telecom-accordion-item {
    margin-bottom: 18px;
  }

  .telecom-accordion-header {
    background: linear-gradient(90deg, #2fb7a4 0%, #2f6f9f 60%, #2f4a7f 100%);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }

  .telecom-accordion-arrow {
    font-size: 22px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .telecom-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet (≤ 1024px) ── */
  @media (max-width: 1024px) {
    .telecom-header {
      height: auto;
      min-height: 90px;
    }

    .telecom-header-badge {
      max-width: 100%;
      padding: 10px 14px;
    }

    .telecom-title-group h2 {
      font-size: 24px;
    }

    .telecom-main {
      padding: 40px 40px;
      gap: 40px;
    }
  }

  /* ── Small tablet / large phone (≤ 768px) ── */
  @media (max-width: 768px) {
    .telecom-header {
      flex-direction: column;
      height: auto;
    }

    .telecom-header-left {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .telecom-header-right {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .telecom-triangle-left,
    .telecom-triangle-right {
      width: 50px;
    }

    .telecom-title-group h2 {
      font-size: 20px;
    }

    .telecom-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .telecom-img-wrapper {
      width: 100%;
    }

    .telecom-img-wrapper img {
      max-width: 100%;
    }

    .telecom-accordion {
      width: 100%;
    }
  }

  /* ── Mobile (≤ 480px) ── */
  @media (max-width: 480px) {
    .telecom-header {
      flex-direction: column;
      height: auto;
    }

    .telecom-header-left {
      min-height: 60px;
      padding: 10px 12px;
    }

    .telecom-header-badge {
      padding: 10px 12px;
      gap: 8px;
    }

    .telecom-header-badge span:first-of-type {
      font-size: 12px;
    }

    .telecom-header-icon-box {
      width: 30px;
      height: 30px;
      min-width: 30px;
    }

    .telecom-header-right {
      min-height: 60px;
      padding: 10px 12px;
    }

    .telecom-triangle-left,
    .telecom-triangle-right {
      width: 36px;
    }

    .telecom-title-group h2 {
      font-size: 15px;
    }

    .telecom-title-group svg {
      font-size: 22px !important;
    }

    .telecom-main {
      padding: 20px 12px;
      gap: 20px;
    }

    .telecom-accordion-header {
      font-size: 13px;
      padding: 8px 14px;
    }

    .telecom-accordion-arrow {
      font-size: 18px;
    }

    .telecom-accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }
  }

  /* ── Extra small (≤ 360px) ── */
  @media (max-width: 360px) {
    .telecom-title-group h2 {
      font-size: 13px;
    }

    .telecom-accordion-header {
      font-size: 12px;
      padding: 6px 10px;
    }
  }
`;

function TelecommunicationPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Virtual Assistance",
      content:
        "AI support traffic, reducing call time wait for customers, maintaining and troubleshooting problems"
    },
    {
      title: "2.Fraud Detection",
      content:
        "AI based applications use machine learning algorithms to detect abnormal traffic and stop fraudulent practices."
    },
    {
      title: "3.Predictive Analytics",
      content:
        "AI-driven applications enable companies to take preventive measures by analysing patterns and trends."
    },
    {
      title: "4.Client Sentiment Analysis",
      content:
        "AI sentiment analysis works by analyzing customer behavior, preferences, and patterns."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* HEADER */}
      <div className="telecom-header">
        {/* LEFT */}
        <div
          className="telecom-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="telecom-header-overlay" />

          <div className="telecom-header-badge">
            <div className="telecom-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Artificial Intelligence - Use Cases</span>
            <span className="telecom-arrow">›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="telecom-header-right">
          <div className="telecom-triangle-left" />
          <div className="telecom-triangle-right" />

          <div className="telecom-title-group">
            <TbSettingsCog style={{ fontSize: "32px", color: "#2fb7a4" }} />
            <h2>Telecommunication</h2>
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="telecom-main">
        {/* IMAGE */}
        <div className="telecom-img-wrapper">
          <img src={telecomImg} alt="Telecommunication" />
        </div>

        {/* ACCORDION */}
        <div className="telecom-accordion">
          {data.map((item, i) => (
            <div key={i} className="telecom-accordion-item">
              <div
                className="telecom-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="telecom-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="telecom-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TelecommunicationPage;
